import { AuthContext } from '@repo-level/core-front';
import { ConfigContext } from 'contexts/config';
import { someGroupMember } from 'helpers/user';
import { useContext, useMemo } from 'react';
import { RESTRICTED_GROUPS } from '../constants';
import { useCycle } from './useCycle';

export const useAvailable = () => {
  const { user } = useContext(AuthContext);
  const { pumpkinRush, isPumpkinRushDateValid } = useContext(ConfigContext);
  const cycle = useCycle();

  const isRestricted = useMemo(
    () => someGroupMember(RESTRICTED_GROUPS)(user),
    [user]
  );

  // seconds, like getTimeLeft; bets of the last week stop counting with the
  // promo, before its Monday
  const timeLeft = useMemo(() => {
    if (!pumpkinRush) return 0;

    const weekEnd = Math.min(
      cycle.end.getTime(),
      new Date(pumpkinRush.end).getTime()
    );

    return Math.max((weekEnd - Date.now()) / 1000, 0);
  }, [pumpkinRush, cycle]);

  return { isAvailable: isPumpkinRushDateValid && !isRestricted, timeLeft };
};
